import React from 'react';
import { useParams } from 'react-router-dom';
import { BodyTextMedium, HeadingText50, ButtonGroup } from '@modernhealth/vital-components';
import { useTranslation } from 'react-i18next';
import { useCancelAuthenticatedRsvpMutation } from '@modernhealth/circles-graphql/v2';

import { InternalLinkButton } from 'src/shared/components/InternalLinkButton';

import { ReactComponent as Cancelation } from '../assets/images/Cancelation.svg';
import { SessionCardSkeleton } from '../components/SessionCardSkeletons';
import { BackButton } from '../components/BackButton';
import { Page } from '../components/PageLayout';

interface RsvpParams {
    rsvpId: string;
}

export const CirclesCancellationPage: React.FC<unknown> = () => {
    const { t } = useTranslation('circles');
    const { rsvpId } = useParams<RsvpParams>();

    const [cancelAuthenticatedRsvp, { loading }] = useCancelAuthenticatedRsvpMutation();

    React.useEffect(() => {
        cancelAuthenticatedRsvp({
            variables: {
                rsvpId,
            },
        });
    }, [cancelAuthenticatedRsvp, rsvpId]);

    if (loading) {
        return (
            <div css={{ margin: '0 auto' }}>
                <SessionCardSkeleton />;
            </div>
        );
    }

    return (
        <Page.Container>
            <Page.Header>
                <BackButton />
            </Page.Header>

            <Page.Content
                centered
                alignChildren="center"
                css={{
                    paddingTop: 70,
                    maxWidth: 700,
                }}
            >
                <Cancelation height="15rem" width="15rem" css={{ marginBottom: '3rem' }} />
                <HeadingText50 centered>{t('pages.cancellation.heading')}</HeadingText50>
                <BodyTextMedium centered fontColor="gray55" css={{ marginBottom: '32px' }}>
                    {t('pages.cancellation.message')}
                </BodyTextMedium>
                <ButtonGroup>
                    <InternalLinkButton to="/circles" size="large" variant="secondary">
                        {t('pages.cancellation.action.view_series')}
                    </InternalLinkButton>
                    <InternalLinkButton to="/circles/upcoming" size="large" variant="primary">
                        {t('pages.cancellation.action.view_upcoming')}
                    </InternalLinkButton>
                </ButtonGroup>
            </Page.Content>
        </Page.Container>
    );
};
